var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgforinfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 72C16.1414 72 0 55.8586 0 36C0 16.1414 16.1414 0 36 0C55.8586 0 72 16.1414 72 36C72 55.8586 55.8586 72 36 72ZM36 5.02326C18.9209 5.02326 5.02326 18.9209 5.02326 36C5.02326 53.0791 18.9209 66.9767 36 66.9767C53.0791 66.9767 66.9767 53.0791 66.9767 36C66.9767 18.9209 53.0791 5.02326 36 5.02326Z",
    fill: "#008C1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2178 48.1558C30.5442 48.1558 29.9043 47.8844 29.4328 47.4096L19.9015 37.8104C18.9248 36.8267 18.9248 35.1986 19.9015 34.215C20.8782 33.2313 22.4947 33.2313 23.4714 34.215L31.2178 42.0164L48.5288 24.5819C49.5055 23.5982 51.1221 23.5982 52.0988 24.5819C53.0755 25.5655 53.0755 27.1936 52.0988 28.1773L33.0028 47.4096C32.5313 47.8844 31.8914 48.1558 31.2178 48.1558Z",
    fill: "#008C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgforinfo);
export default __webpack_public_path__ + "static/media/svgforinfo.3199f7e526d83ea5d0e0c19218707b04.svg";
export { ForwardRef as ReactComponent };